'use client'

import { SiteSetting } from '@/payload-types'
import React, { createContext, use } from 'react'

const initialContext: SiteSetting = {
    id: '',
}

const SiteSettingsContext = createContext(initialContext)

export const SiteSettingsProvider = ({ children, settings }: { children: React.ReactNode; settings: SiteSetting }) => {
    return <SiteSettingsContext value={settings}>{children}</SiteSettingsContext>
}

export const useSiteSettings = (): SiteSetting => use(SiteSettingsContext)
